import React from "react"

import { Paragraph, TitleCenter } from "../../ui"

export const SuccessCell = () => (
  <>
    <TitleCenter>Dados bancários cadastrados com sucesso!</TitleCenter>

    <Paragraph>Parabéns os documentos enviados foram aprovados!</Paragraph>

    <Paragraph>
      A partir de agora os valores serão transferidos para a conta conforme o
      plano de recebimento.
    </Paragraph>
  </>
)
